const tranformDataToArray = (arr: Array<number> | ArrayBuffer | string): Uint8Array => {
  let buffer: ArrayBuffer;

  if (Array.isArray(arr)) {
    buffer = new ArrayBuffer(arr.length);
    const view = new Uint8Array(buffer);
    arr.forEach((v, indx) => {
      view[indx] = v;
    });
    return view;
  } else if (arr instanceof ArrayBuffer) {
    return new Uint8Array(arr);
  } else if (typeof arr === 'string') {
    const encoder = new TextEncoder();
    return encoder.encode(arr);
  } else {
    throw new Error('Invalid input type. Expected Array<number>, ArrayBuffer, or string.');
  }
};

export { tranformDataToArray };
